import React from 'react';

import AgingDashboardContainer from '@totem/components/ticketing/agingDashboard/AgingDashboardContainer';
import AgingDashboardLayout from '@totem/components/ticketing/agingDashboard/AgingDashboardLayout';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

const AgingDashboardPage = () => (
  <ContentLayout>
    <AgingDashboardContainer>
      <AgingDashboardLayout />
    </AgingDashboardContainer>
  </ContentLayout>
);

export default AgingDashboardPage;
